module.exports = __webpack_public_path__ + "img/ic_evaluation_method.ad5c5876.svg";